export const staticDb = {
  taskExtendedStatus: [
    {
      statusName: "ASSIGNED",
      key: "ASSIGNED",
      statusId: "ASSIGNED"
    },
    {
      statusName: "COMPLETED",
      key: "COMPLETED",
      statusId: "COMPLETED"
    },
    {
      statusName: "DEFERRED",
      key: "DEFERRED",
      statusId: "DEFERRED"
    },
    {
      statusName: "DELAYED",
      key: "DELAYED",
      statusId: "DELAYED"
    },
    {
      statusName: "UPCOMING",
      key: "UPCOMING",
      statusId: "UPCOMING"
    }
  ],
  expiredToken: "",
  statsAllTasks: {
    path: "statsAllTasks",
    queryObj: {
      path: "tasks",
      criteria: {
        andArray: [],
        orArray: []
      },
      statQuery: {
        path: "tasks",
        targetOperation: "COUNT",
        groupBy: "taskStatus"
      }
    }
  },
  statsMyTasks: {
    path: "statsMyTasks",
    queryObj: {
      path: "tasks",
      criteria: {
        andArray: [],
        orArray: []
      },
      statQuery: {
        path: "tasks",
        targetOperation: "COUNT",
        groupBy: "taskStatus"
      }
    }
  },
  statsAllProjects: {
    path: "statsAllProjects",
    queryObj: {
      path: "projects",
      criteria: {},
      statQuery: {
        path: "projects",
        targetOperation: "COUNT",
        groupBy: "projectPhase"
      }
    }
  },
  statsAllProjectQuotes: {
    path: "statsAllProjectQuotes",
    queryObj: {
      path: "projectQuotes",
      criteria: {},
      statQuery: {
        path: "projectQuotes",
        targetOperation: "SUM",
        sumField: "totalAmount"
      }
    }
  },
  statsAllProjectInvoices: {
    path: "statsAllProjectInvoices",
    queryObj: {
      path: "tasks",
      criteria: {},
      statQuery: {
        path: "projectInvoices",
        targetOperation: "SUM",
        sumField: "totalInvoice",
        groupBy: "invoiceStatus"
      }
    }
  },
  statsAllAttendance: {
    path: "statsAllProjectInvoices",
    queryObj: {
      path: "tasks",
      criteria: {},
      statQuery: {
        path: "projectInvoices",
        targetOperation: "SUM",
        sumField: "totalInvoice",
        groupBy: "invoiceStatus"
      }
    }
  },
  reportings: [
    {
      displayName: "ATTENDANCE",
      tableName: "attendance",
      groupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" },
        { displayName: "EMPLOYEE", fieldName: "employeeName" }
      ],
      subGroupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" },
        { displayName: "EMPLOYEE", fieldName: "employeeName" }
      ],
      sumFields: [
        { displayName: "OT HOURS", fieldName: "otHours" },
        { displayName: "WEEKDAYS", fieldName: "weekdays" },
        { displayName: "SUNDAYS", fieldName: "sundays" },
        { displayName: "PUBLIC HOLIDAYS", fieldName: "phDays" }
      ],
      filters: [
        { displayName: "MONTHS", fieldName: "month" },
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "EMPLOYEE", fieldName: "employeeName" }
      ],
      show: {
        gb: true,
        sgb: true,
        months: true,
        projects: true,
        employee: true
      }
    },
    {
      displayName: "PURCHASE ORDERS",
      tableName: "projectPos",
      groupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" }
      ],
      subGroupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" }
      ],
      sumFields: [{ displayName: "PO TOTAL", fieldName: "poAmount" }],
      filters: [
        { displayName: "MONTHS", fieldName: "month" },
        { displayName: "PROJECT", fieldName: "projectName" }
      ],
      show: {
        gb: true,
        sgb: true,
        months: true,
        projects: true,
        employee: false
      }
    },
    {
      displayName: "INVOICES",
      tableName: "projectInvoices",
      groupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" }
      ],
      subGroupBy: [
        { displayName: "PROJECT", fieldName: "projectName" },
        { displayName: "MONTH", fieldName: "month" }
      ],
      sumFields: [{ displayName: "INVOICE TOTAL", fieldName: "totalInvoice" }],
      filters: [
        { displayName: "MONTHS", fieldName: "month" },
        { displayName: "PROJECT", fieldName: "projectName" }
      ],
      show: {
        gb: true,
        sgb: true,
        months: true,
        projects: true,
        employee: false
      }
    }
  ],
  reports: {
    reportName: "test report",
    displayName: "ATTENDANCE",
    tableName: "attendance",
    selectedGroupBy: [{ displayName: "MONTH", fieldName: "month" }],
    SelectedSubGroupBy: [],
    selectedSumFields: [{ displayName: "OT HOURS", fieldName: "otHours" }],
    selectedFilters: [
      {
        displayName: "PROJECT",
        fieldName: "projectName",
        values: ["abc"]
      }
    ]
  },
  createFields: {
    key: "",
    name: "",
    lastAction: "",
    updateDateTime: "",
    createDateTime: "",
    author: ""
  },
  createTable: {
    key: "",
    name: "",
    lastAction: "",
    updateDateTime: "",
    createDateTime: "",
    author: ""
  },
  listOfTables: {
    key: "",
    name: "",
    caption: "",
    menu: "",
    updateDateTime: "",
    createDateTime: "",
    author: ""
  },
  menuDesigner: {
    name: "",
    menuItems: [""]
  }
};



// WEBPACK FOOTER //
// ./src/staticData/db.js